<div class="modal-backdrop fade show" @click="close_file_preview_modal"></div>
<div class="modal show d-block" tabindex="-1">
  <div class="modal-dialog modal-xl modal-dialog-centered" @click.stop>
    <div class="modal-content">
      <div class="modal-header shadow-lg modal-lg modal-dialog-centered">
        <h5 class="modal-title d-flex align-items-center">
          <p class="text-black mb-0">Previewing File</p>
        </h5>
        <button
          type="button"
          class="btn-close"
          @click="close_file_preview_modal"
          aria-label="Close"
        ></button>
      </div>

      <div class="modal-body p-0">
        <div class="h-100">
          <iframe
            v-if="file_type === 'pdf' && preview_url"
            :src="preview_url"
            width="100%"
            height="500px"
            frameborder="0"
          ></iframe>

          <img
            v-else-if="['jpg', 'jpeg', 'png', 'gif', 'webp', 'svg'].includes(file_type) && preview_url"
            :src="preview_url"
            :alt="internal_file_name"
            class="img-fluid w-100"
            height="500px"
          >

          <video
            v-else-if="['mp4', 'webm', 'avi', 'mov', 'wmv'].includes(file_type) && preview_url"
            :src="preview_url"
            controls
            class="w-100"
            height="500px"
          >
            Your browser does not support the video tag.
          </video>

          <div
            v-else-if="['mp3', 'wav', 'ogg', 'm4a'].includes(file_type) && preview_url"
            class="d-flex justify-content-center align-items-center h-100 bg-dark"
            style="min-height: 500px;"
          >
            <audio :src="preview_url" controls class="w-75"></audio>
          </div>

          <iframe
            v-else-if="['txt', 'json', 'xml'].includes(file_type) && preview_url"
            :src="preview_url"
            width="100%"
            height="500px"
            frameborder="0"
          ></iframe>

          <div
            v-else-if="is_office_file"
            class="d-flex justify-content-center align-items-center bg-light"
            style="min-height: 500px;"
          >
            <iframe
              v-if="office_preview_url"
              :src="office_preview_url"
              width="100%"
              height="500px"
              frameborder="0"
              :title="internal_file_name"
            ></iframe>

            <div v-else class="text-center p-4">
              <i class="far fa-file-word display-4 text-secondary mb-3"></i>
              <h4>Opening in editor</h4>
              <p class="text-muted">
                Microsoft Office files are previewed in Collabora.
              </p>
              <button
                type="button"
                class="btn cta-button text-white"
                @click="$emit('open-office-file')"
              >
                Open in Editor
              </button>
            </div>
          </div>

          <div
            v-else
            class="d-flex justify-content-center align-items-center h-100 bg-light"
            style="min-height: 500px;"
          >
            <div class="text-center p-4">
              <i class="far fa-file display-4 text-secondary mb-3"></i>
              <h4>Preview not available</h4>
              <p class="text-muted">
                This file type cannot be previewed in the browser.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="modal-footer bg-light">
        <a
          v-if="preview_url && can_download"
          :href="preview_url"
          :download="internal_file_name"
          class="btn cta-button text-white"
        >
          Download
        </a>
      </div>
    </div>
  </div>
</div>
